import type { AuthType, CustomFieldDef, GlobalSetting } from '~/types/blog'

export async function useSiteData() {
  const blogApi = useBlogApi()
  const state = useState<{
    setting: GlobalSetting
    globalFields: CustomFieldDef[]
    authTypes: AuthType[]
  } | null>('site-data', () => null)

  if (!state.value) {
    const [setting, globalFields, authTypes] = await Promise.all([
      blogApi.getGlobalSetting(),
      blogApi.getFieldDefList('global'),
      blogApi.getAuthTypeList()
    ])
    state.value = { setting, globalFields, authTypes }
  }

  return state.value
}
